import { FC, useEffect, useState } from "react";
import { Card, CardBody, Col, Form, FormGroup, Label, Row } from "reactstrap";
import ModalComponent from "../../shared/base-components/Modal";
import TextField from "../../shared/base-components/TextField";
import { SubmitHandler, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import Button from "../../shared/base-components/Button";

import { MODAL_TYPES, RESPONSE_CODE } from "../../shared/models/Types";
import { successNotify } from "../../shared/utils/notifications";
import {
  DeviceModalProps,
  deviceAddSchema,
  deviceUpdateSchema,
} from "./Stock.constants";
import SelectBox from "../../shared/base-components/SelectBox";
import {
  useDeviceAddMutation,
  useDevicePartListMutation,
  useDeviceUpdateMutation,
} from "./Stock.actions";
import { Link } from "react-router-dom";

const DeviceModal: FC<DeviceModalProps> = ({
  deviceData,
  isModalOpen,
  modalType,
  toggle,
  deviceListMutation,
}) => {
  const isMobile: boolean = /iPhone|iPad|iPod|Android/i.test(
    navigator.userAgent
  );

  const isEdit = modalType === MODAL_TYPES.UPDATE;

  const {
    control,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm<any>({
    resolver: yupResolver(isEdit ? deviceAddSchema : deviceUpdateSchema),
  });

  const { data: devicePartListData, mutate: devicePartListMutation } =
    useDevicePartListMutation();
  const {
    data: devicePartAddData,
    mutate: devicePartAddMutation,
    isLoading: deviceAddloading,
  } = useDeviceAddMutation();
  const {
    data: devicePartUpdateData,
    mutate: devicePartUpdateMutation,
    isLoading: updateLoading,
  } = useDeviceUpdateMutation();

  const [selectedFilters, setSelectedFilters] = useState<any[]>(
    isEdit
      ? deviceData?.device_parts.map((deviceData: any) => deviceData?.id)
      : []
  );
  const [selectedFilter, setSelectedFilter] = useState<any>();

  const onSubmit: SubmitHandler<any> = (requestValues) => {
    requestValues.device_part =
      selectedFilters.length === 0
        ? undefined
        : selectedFilters.map((filters) => {
            return parseFloat(filters);
          });

    isEdit
      ? devicePartUpdateMutation({ ...requestValues, id: deviceData?.id })
      : devicePartAddMutation(requestValues);
  };

  useEffect(() => {
    if (devicePartAddData?.status === RESPONSE_CODE.CREATED) {
      successNotify("Cihaz başarılı bir şekilde oluşturuldu");
      toggle();

      deviceListMutation && deviceListMutation({});
    }
  }, [devicePartAddData]);

  useEffect(() => {
    if (devicePartUpdateData?.status === RESPONSE_CODE.SUCCESS_CODE) {
      successNotify("Cihaz başarılı bir şekilde güncellendi");
      toggle();

      deviceListMutation && deviceListMutation({});
    }
  }, [devicePartUpdateData]);

  useEffect(() => {
    devicePartListMutation({});
  }, []);

  const getFormattedDevicePartResponse = devicePartListData?.map(
    (devicePart) => {
      return { key: devicePart?.name, value: devicePart?.id };
    }
  );

  return (
    <ModalComponent
      header={isEdit ? "Cihaz Güncelle" : "Cihaz Ekle"}
      description={
        isEdit
          ? "Cihaz Güncellemek için ilgili alanı düzeltip onaylayın"
          : "Cihaz eklemek için gerekli alanları doldurunuz."
      }
      isOpen={isModalOpen}
      toggle={toggle}
    >
      <Form onSubmit={handleSubmit(onSubmit)} className="custom-form mt-4 pt-2">
        <Row>
          <Col sm="12" md="6" lg="6">
            <FormGroup className="mb-3">
              <Label className="form-label">Cihaz Adı</Label>
              <TextField
                control={control}
                name="name"
                defaultValue={isEdit ? deviceData?.name : ""}
                type="text"
                className="form-control"
                placeholder="Cihaz adı"
                error={errors.name?.message}
              />
            </FormGroup>
          </Col>

          <Col sm="12" md="6" lg="6">
            <FormGroup className="mb-3">
              <Label htmlFor="validationCustom02">Açıklama</Label>
              <TextField
                control={control}
                name="description"
                className="form-control"
                type="text"
                placeholder="Açıklama"
                error={errors.description?.message}
                defaultValue={isEdit ? deviceData?.description : ""}
              />
            </FormGroup>
          </Col>

          <Col sm="12" md="6" lg="6">
            <FormGroup className="mb-3">
              <Label className="form-label">Garanti Süresi (Ay)</Label>
              <TextField
                control={control}
                name="warranty_period"
                type="number"
                className="form-control"
                defaultValue={isEdit ? deviceData?.warranty_period : 0}
                placeholder="Garanti süresi"
                error={errors.warranty_period?.message}
              />
            </FormGroup>
          </Col>

          <Col sm="12" md="6" lg="6">
            <FormGroup className="mb-3">
              <Label htmlFor="validationCustom02">Sistem</Label>
              <SelectBox
                control={control}
                name="system"
                className="form-control"
                onChangeHandler={(e) => {
                  setValue("system", e.target.value);
                }}
                options={[
                  { key: "Açık sistem", value: "open" },
                  { key: "Kapalı sistem", value: "close" },
                ]}
                defaultValue={isEdit ? deviceData?.system : "close"}
              />
            </FormGroup>
          </Col>

          <Col sm="12" md="12" lg="12">
            <FormGroup className="mb-3">
              <Label className="form-label">Malzeme Ekle</Label>

              <Card className={"mb-xl-0"}>
                <CardBody>
                  {selectedFilters && !selectedFilters.length && (
                    <p className={"text-muted mt-3 font-size-15"}>
                      Eklemek istediğiniz malzemeyi seçiniz.
                    </p>
                  )}

                  <Col sm="12" md="12" lg="12">
                    <ul
                      style={{ padding: "2" }}
                      className="list-unstyled  mb-4"
                    >
                      {selectedFilters !== undefined &&
                        selectedFilters?.map(
                          (selectedFiltre: any, index: number) => {
                            return (
                              <li
                                style={{
                                  borderBottom: "1px solid #7b8198",
                                  paddingBottom: 11,
                                }}
                                key={selectedFiltre}
                              >
                                <div className="d-flex align-items-start">
                                  <div className="flex-grow-1 overflow-hidden h-2">
                                    <h5 className="text-truncate font-size-14 mt-2">
                                      {
                                        getFormattedDevicePartResponse?.find(
                                          (devicePart) =>
                                            devicePart.value == selectedFiltre
                                        )?.key
                                      }
                                    </h5>
                                  </div>

                                  <div className="d-flex align-items-start justify-content-end gap-3 mt-2">
                                    <Link
                                      to={"#"}
                                      onClick={() => {
                                        const selectedIndex =
                                          selectedFilters.indexOf(
                                            selectedFiltre
                                          );

                                        if (selectedIndex !== -1) {
                                          selectedFilters.splice(
                                            selectedIndex,
                                            1
                                          );
                                        }
                                      }}
                                      className="badge btn btn-danger rounded-pill font-size-10 p-2 pointer"
                                    >
                                      <i className="mdi mdi-close noti-icon"></i>{" "}
                                      Sil
                                    </Link>
                                  </div>
                                </div>
                              </li>
                            );
                          }
                        )}
                    </ul>
                  </Col>

                  <div className={"mt-4 pt-2 text-muted"}>
                    <Col sm="12" md="12" lg="12">
                      <FormGroup className="mb-3">
                        <Label className="form-label">Malzeme Ekle</Label>
                        <Card className={"mb-xl-0"}>
                          <CardBody>
                            <Row>
                              <Col sm="12" md="6" lg="6">
                                {getFormattedDevicePartResponse && (
                                  <SelectBox
                                    name="devicePart"
                                    className="form-control"
                                    onChangeHandler={(e) =>
                                      setSelectedFilter(e.target.value)
                                    }
                                    options={[
                                      {
                                        key: "Lütfen malzeme seçin",
                                        value: -1,
                                      },
                                      ...getFormattedDevicePartResponse,
                                    ]}
                                    defaultValue={
                                      isEdit ? deviceData?.system : ""
                                    }
                                  />
                                )}
                              </Col>

                              <Col
                                className={isMobile ? "mt-3" : ""}
                                sm="12"
                                md="6"
                                lg="6"
                              >
                                <Link
                                  onClick={() =>
                                    selectedFilter > 0 &&
                                    selectedFilter.length &&
                                    setSelectedFilters((prevState) => [
                                      ...prevState,
                                      selectedFilter,
                                    ])
                                  }
                                  to="#"
                                  className={"btn btn-success w-100"}
                                >
                                  Malzeme Ekle
                                </Link>
                              </Col>
                            </Row>
                          </CardBody>
                        </Card>
                      </FormGroup>
                    </Col>
                  </div>
                </CardBody>
              </Card>
            </FormGroup>
          </Col>

          <Col md="12">
            <FormGroup className="mb-3">
              <Button
                loading={isEdit ? updateLoading : deviceAddloading}
                text={isEdit ? "Cihaz Güncelle" : "Cihaz Ekle"}
                variant="primary"
              />
            </FormGroup>
          </Col>
        </Row>
      </Form>
    </ModalComponent>
  );
};

export default DeviceModal;
